import { cn } from "./cn.ts";

export interface ScopeNode {
  readonly id: string;
  readonly name: string;
  readonly parentScopeId: string | null;
}

/** Bộ chọn scope dạng cây (`role="tree"`); chọn lại nút đang chọn ⇒ bỏ lọc. Nhãn theo `scope.type` do nơi gọi truyền. */
export function ScopePicker({ label, allLabel, scopes, selected, onSelect }: { label: string; allLabel: string; scopes: readonly ScopeNode[]; selected: string | null; onSelect: (id: string | null) => void }) {
  const children = (parent: string | null) => scopes.filter((s) => s.parentScopeId === parent);
  const render = (parent: string | null, level: number): React.ReactNode =>
    children(parent).map((s) => {
      const sub = children(s.id);
      return (
        <li key={s.id} role="treeitem" aria-level={level} aria-selected={selected === s.id} aria-expanded={sub.length ? true : undefined}>
          <button type="button" className={cn("w-full rounded px-2 py-1 text-left text-sm hover:bg-(--saa-muted)", selected === s.id && "bg-(--saa-muted) font-medium")} onClick={() => onSelect(selected === s.id ? null : s.id)}>
            {s.name}
          </button>
          {sub.length ? (
            <ul role="group" className="ml-3">
              {render(s.id, level + 1)}
            </ul>
          ) : null}
        </li>
      );
    });
  return (
    <nav aria-label={label}>
      <ul role="tree" aria-label={label} className="flex flex-col gap-0.5">
        <li role="treeitem" aria-level={1} aria-selected={selected === null}>
          <button type="button" className={cn("w-full rounded px-2 py-1 text-left text-sm hover:bg-(--saa-muted)", selected === null && "bg-(--saa-muted) font-medium")} onClick={() => onSelect(null)}>
            {allLabel}
          </button>
        </li>
        {render(null, 1)}
      </ul>
    </nav>
  );
}
